import { FC, useMemo } from 'react';

import { Box, Typography } from '@mui/material';

import { useCountries } from 'src/hooks/useCountries';

interface CountryDisplay {
    label: string;
    country: string;
    value: string;
}

export const CountryDisplay: FC<CountryDisplay> = ({ label, country, value }) => {
    const { countries } = useCountries();

    const countryData = useMemo(() => {
        return countries.find((el) => el.name === country);
    }, [countries, country]);

    return (
        <Box flex={0.5} padding="8px">
            <Typography
                fontSize="14px"
                color="#1D1D1B"
                fontWeight="600"
                lineHeight="21px"
                marginBottom="24px"
            >
                {label}
            </Typography>

            <Box display="flex" alignItems="center">
                {countryData?.flag && (
                    <img
                        src={countryData?.flag}
                        alt="country flag"
                        style={{
                            borderRadius: '50%',
                            height: '24px',
                            width: '24px',
                            objectFit: 'cover',
                        }}
                    />
                )}
                <Typography
                    fontSize="20px"
                    color="#8E8E8D"
                    fontWeight="400"
                    lineHeight="30px"
                    marginLeft="8px"
                >
                    {value}
                </Typography>
            </Box>
        </Box>
    );
};
